<template>
  <div class="hotel">
    <div class="hotel__photo">
      <img
        :src="img"
        :alt="name"
      >
    </div>
    <div class="hotel__data">
      <table class="table-hotel">
        <tr>
          <th>Hotel Id</th>
          <th colspan="2">
            Hotel Name
          </th>
          <th>Address</th>
          <th>City</th>
          <th>Mappings</th>
        </tr>
        <tr>
          <td>{{ id }}</td>
          <td colspan="2">
            {{ name }}
          </td>
          <td>{{ address }}</td>
          <td>{{ city }}</td>
          <td>{{ mappings }}</td>
        </tr>
        <tr>
          <th>Stars</th>
          <th>Rooms</th>
          <th>Zip Code</th>
          <th colspan="3">
            Lat/Lng
          </th>
        </tr>
        <tr>
          <td>{{ stars }}</td>
          <td>{{ rooms }}</td>
          <td>{{ zipCode }}</td>
          <td>
            {{ lat }}/{{ lng }}
          </td>
          <td colspan="2">
            &nbsp;
          </td>
        </tr>
        <tr>
          <th>Phone</th>
          <th colspan="2">
            Email
          </th>
          <th colspan="3">
            Website
          </th>
        </tr>
        <tr>
          <td>{{ phone }}</td>
          <td
            colspan="2"
            style="word-wrap: break-word;"
          >
            <a
              :href="`mailto:${email}`"
              :title="email"
              style="color: currentColor; text-decoration: none;"
            >{{ email }}</a>
          </td>
          <td colspan="3">
            <a
              :href="website"
              :title="website"
              style="color: currentColor; text-decoration: none;"
              target="_blank"
            >{{ websiteDomain }}</a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'hotel-short-data',
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    city: {
      type: String,
      required: true,
    },
    mappings: {
      type: Number,
      required: true,
    },
    stars: {
      type: [Number, String],
      required: true,
    },
    rooms: {
      type: Number,
      required: true,
    },
    zipCode: {
      type: [Number, String],
      required: true,
    },
    lat: {
      type: [Number, String],
      required: true,
    },
    lng: {
      type: [Number, String],
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    website: {
      type: String,
      required: true,
    },
  },
  computed: {
    websiteDomain() {
      return new URL(this.website).hostname;
    },
  },
};
</script>

<style scoped lang="scss">
.hotel {
  display: flex;
  flex: 1;
  align-items: flex-start;

  @media screen and (max-width: 1023px) {
    flex-direction: column;
  }

  &__photo {
    width: 300px;
    height: 200px;
    flex: 0 0 auto;
    margin-right: 24px;
    position: relative;

    @media screen and (max-width: 768px) {
      display: none;
    }

    @media screen and (max-width: 1023px) {
      margin-right: 0;
      margin-bottom: 10px;
    }

    @media screen and (max-width: 1200px) {
      width: 200px;
      height: 133.33px;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }

  &__data {
    flex: 0 1 auto;
    .table-hotel {
      width: 100%;
      max-width: 880px;
      th {
        text-align: left;
        font-size: 9px;
        text-transform: uppercase;
        line-height: 12px;
        padding: 5px 13px;
        @media screen and (max-width: 1024px) {
          padding: 2px 5px;
        }
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
      }
      td {
        font-size: 13px;
        line-height: 16px;
        font-weight: 500;
        padding: 0 13px 15px;
        @media screen and (max-width: 1024px) {
          padding: 0 5px 7px;
        }
        @media screen and (min-width: 1200px) {
          min-width: 100px;
        }
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
        &[colspan="2"] {
          max-width: 200px;
        }
      }
      tr ~ tr th {
        padding-top: 15px;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        @media screen and (max-width: 1024px) {
          padding-top: 7px;
        }
      }
    }
  }
}
</style>
